import FeatureFlagsPage from '@playground/features/feature-flags/FeatureFlagsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_superAdmin/feature-flags')({
  component: FeatureFlagsPage,
})
